/**
 * Mock fixo com todas as etapas do NEG Execution
 * Esse template é usado para exibir todas as etapas na tela,
 * mesmo as que ainda não foram processadas pela API
 */

export interface NegExecutionTemplateSubStep {
  stepId: string;
  name: string;
}

export interface NegExecutionTemplateStep {
  stepId: string;
  message: string;
  steps?: NegExecutionTemplateSubStep[];
}

/** @deprecated Use NegExecutionTemplateStep */
export type NegStepTemplate = NegExecutionTemplateStep;

/** @deprecated Use NegExecutionTemplateSubStep */
export type NegSubStepTemplate = NegExecutionTemplateSubStep;

export const NEG_EXECUTION_STEPS: NegExecutionTemplateStep[] = [
  {
    stepId: "01",
    message: "Etapa 01: Seleção de pedidos",
  },
  {
    stepId: "02",
    message: "Etapa 02: Seleção da projeção de estoque cervejaria e CDD",
  },
  {
    stepId: "03",
    message: "Etapa 03: Cálculo do volume de marcação",
  },
  {
    stepId: "04",
    message: "Etapa 04: Cálculo projeção de estoque considerando produção",
  },
  {
    stepId: "05",
    message: "Etapa 05: Envio de dados para automação",
  },
  {
    stepId: "06",
    message: "Etapa 06: Consumo de dados automação",
  },
  {
    stepId: "07",
    message: "Etapa 07: Executar cortes por regional",
    steps: [
      { stepId: "07-CO", name: "Regional CO" },
      { stepId: "07-SUL", name: "Regional SUL" },
      { stepId: "07-SP", name: "Regional SP" },
      { stepId: "07-RIO", name: "Regional RIO" },
      { stepId: "07-MG", name: "Regional MG" },
      { stepId: "07-NE", name: "Regional NE" },
    ],
  },
  {
    stepId: "FIM",
    message: "Fim da Rodada",
  },
];

/**
 * Extrai o número da etapa de uma mensagem da API
 * @example "Etapa 1 - Seleção de pedidos finalizada - Rodada 358" => "01"
 * @example "ETAPA 7: Executar cortes por regionais - Rodada 358" => "07"
 */
export const extractStepNumber = (message: string): string | null => {
  const match = message.match(/etapa\s*(\d+)/i);
  if (match) {
    return match[1].padStart(2, "0");
  }
  return null;
};

/**
 * Extrai o nome da regional de uma mensagem da API
 * @example "Processando corte de pedidos no SAP - CO" => "CO"
 */
export const extractRegionalName = (name: string): string | null => {
  const match = name.match(/-\s*([A-Z]+)\s*$/i);
  if (match) {
    return match[1].toUpperCase();
  }
  return null;
};

/**
 * Verifica se todas as etapas foram concluídas com sucesso (para mostrar "Fim da Rodada")
 */
export const isAllStepsCompleted = (
  apiData: Sentinel.NegExecution.Response | undefined
): boolean => {
  if (!apiData?.length) return false;

  // Verifica se a etapa 7 existe e está com status FINISH
  const step7 = apiData.find((item) => {
    const stepNum = extractStepNumber(item.message);
    return stepNum === "07";
  });

  return step7?.eventType?.toUpperCase() === "FINISH";
};
